export default __webpack_public_path__ + "static/media/40271.583ca614.jpg";